<script src="../router/index.js"></script>
<template>
  <div style="position: relative;width: 100%">
    <indexTitle>{{$t(`lang.${title}`)}} </indexTitle>

    <span class="seemore" v-if="more" @click="go2seeMore">{{$t('lang.查看更多')}} <i class="iconfont icon-right1"></i></span>
  </div>
</template>

<script>
  import {createProp} from '@common/utils'

  export default {
    props: {
      title: createProp(String),
      more: createProp([String, Boolean,], {default: true})
    },
    components: {
      indexTitle: () => import("./indexTitle.vue"),
    },
    methods: {
      go2seeMore() {
        this.$emit("go2seeMore")
      }
    }
  }
</script>

<style scoped lang="less">
  .seemore {
    font-size: 16px;
    color: #666666;

    position: absolute;
    right: 10px;
    top: 30%;
    transform: translateY(-30%);
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/wenxing/components/seeMoreAndTitleRow.vue